import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
        <div className='footer' style={{width: '100%', height: '3vh',backgroundColor: '#000000e6',color: '#3dfffc',margin:'30px 0px 0px 0px'}}>
          © 2022 Copyright:  <a href='https://github.com/Khushii-Arora'> Khushi Arora </a>
        </div>

      
    );
  }
}

export default Footer;
